<form
	class=""
	[formGroup]="form"
	novalidate
>
	<div class="sdp-form-control">
		<mat-slide-toggle
			formControlName="dnsEnabled"
			(change)="toggleDnsEnabled($event)"
		>
			{{ "sdp.gateway.customDNS" | translate }}
		</mat-slide-toggle>
		<sdp-icon
			class="sdp-gateway-dns-help-icon"
			[icon]="helpIcon"
		></sdp-icon>
	</div>
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input
				matInput
				placeholder="{{ 'form.label.dns1' | translate }}"
				type="text"
				formControlName="dnsServer1"
				[errorStateMatcher]="dnsServerMatcher"
			>
			<mat-error *ngIf="form.controls['dnsServer1'].hasError('required')">
				{{ "error.message.dns.required" | translate }}</mat-error>
			<mat-error *ngIf="!form.controls['dnsServer1'].hasError('required') && form.controls['dnsServer1'].hasError('invalidIp')">
				{{ "error.message.dns.invalid" | translate }}</mat-error>
		</mat-form-field>
	</div>
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input
				matInput
				placeholder="{{ 'form.label.dns2' | translate }}"
				type="text"
				formControlName="dnsServer2"
				[errorStateMatcher]="dnsServerMatcher"
			>
			<mat-error *ngIf="form.controls['dnsServer2'].hasError('invalidIp')">
				{{ "error.message.dns.invalid" | translate }}</mat-error>
			<mat-error *ngIf="form.hasError('valuesAreSame')">
				{{ "error.message.dns.same" | translate }}
			</mat-error>
		</mat-form-field>
	</div>
	<div class="sdp-form-control">
		<mat-slide-toggle
			formControlName="dnsSuffixEnabled"
			(change)="toggleDnsSuffixEnabled($event)"
		>
			{{ "sdp.gateway.customDNSSuffix" | translate }}
		</mat-slide-toggle>
		<sdp-icon
			class="sdp-gateway-dns-help-icon"
			[icon]="dnsSuffixHelpIcon"
		></sdp-icon>
	</div>
	<div class="sdp-form-control">
		<mat-form-field class="sdp-form-control-input-container">
			<input
				matInput
				placeholder="{{ 'form.label.dnsSuffix' | translate }}"
				type="text"
				formControlName="dnsSuffix"
			>
			<mat-error *ngIf="form.controls['dnsSuffix'].hasError('required')">
				{{ "error.message.dns.suffix.required" | translate }}
			</mat-error>
			<mat-error *ngIf="!form.controls['dnsSuffix'].hasError('required') && form.controls['dnsSuffix'].hasError('invalidDomain')">
				{{ "error.message.dns.suffix.invalid" | translate }}
			</mat-error>
		</mat-form-field>
	</div>
</form>